/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterExclusion
 */
export interface GlobalFilterExclusion {
    /**
     * EventPipelineFilter _id this entity skips. 24-character hex.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    filterId: string;
    /**
     * Absent = the whole rule is skipped here. Present = only this line of the rule is skipped here.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    conditionId?: string;
    /**
     * Why this was skipped here. Required — governance is enforced at the schema, not the form.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    reason: string;
    /**
     * Admin user _id who created the skip. Stamped server-side.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    excludedBy: string;
    /**
     * Epoch ms the skip was created. Stamped server-side.
     * @type {number}
     * @memberof GlobalFilterExclusion
     */
    excludedAt: number;
    /**
     * Absent = the skip lasts for the life of the competition. When present, enforced at read — the skip stops applying the moment it passes.
     * @type {number}
     * @memberof GlobalFilterExclusion
     */
    expiresAt?: number;
}

/**
 * Check if a given object implements the GlobalFilterExclusion interface.
 */
export function instanceOfGlobalFilterExclusion(value: object): value is GlobalFilterExclusion {
    if (!('filterId' in value) || value['filterId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('excludedBy' in value) || value['excludedBy'] === undefined) return false;
    if (!('excludedAt' in value) || value['excludedAt'] === undefined) return false;
    return true;
}

export function GlobalFilterExclusionFromJSON(json: any): GlobalFilterExclusion {
    return GlobalFilterExclusionFromJSONTyped(json, false);
}

export function GlobalFilterExclusionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterExclusion {
    if (json == null) {
        return json;
    }
    return {
        
        'filterId': json['filterId'],
        'conditionId': json['conditionId'] == null ? undefined : json['conditionId'],
        'reason': json['reason'],
        'excludedBy': json['excludedBy'],
        'excludedAt': json['excludedAt'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
    };
}

export function GlobalFilterExclusionToJSON(json: any): GlobalFilterExclusion {
    return GlobalFilterExclusionToJSONTyped(json, false);
}

export function GlobalFilterExclusionToJSONTyped(value?: GlobalFilterExclusion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filterId': value['filterId'],
        'conditionId': value['conditionId'],
        'reason': value['reason'],
        'excludedBy': value['excludedBy'],
        'excludedAt': value['excludedAt'],
        'expiresAt': value['expiresAt'],
    };
}

